import { useMemo } from "react";
import { useApi } from "./useApi";
import { toList } from "../lib/api";

export function useRosterNames(tid) {
  const { data } = useApi(tid && `/teams/${tid}/players`);
  return useMemo(() => Object.fromEntries(toList(data, ["players"]).map((p) => [p.id, `#${p.jersey ?? "–"} ${p.name}`])), [data]);
}
